import type { Company, NavGroup } from './interfaces/side-bar.interface';
import { PERMISSIONS } from '@shared/constants/permissions/permissions';

export const NAV_GROUPS: NavGroup[] = [
  {
    items: [{ icon: 'home', label: 'Inicio', routerLink: '/' }],
  },
  {
    items: [
      {
        icon: 'cog',
        label: 'Administración',
        subItems: [
          {
            label: 'Ejemplo',
            routerLink: '/admin/example',
          },
          { label: 'Marca Blanca', visible: false },
          {
            label: 'Propietarios',
            routerLink: '/admin/owners',
            requiredPermissions: [PERMISSIONS.OWNERS.SHOW_DATA],
          },
          { label: 'Usuarios', visible: false },
        ],
      },
    ],
  },
  {
    items: [
      {
        icon: 'building',
        label: 'Instalaciones',
        subItems: [
          {
            label: 'Almacenes',
            routerLink: '/facilities/warehouses',
            requiredPermissions: [PERMISSIONS.WAREHOUSES.SHOW_DATA],
          },
          {
            label: 'Áreas',
            routerLink: '/facilities/areas',
            requiredPermissions: [PERMISSIONS.AREAS.SHOW_DATA],
          },
          {
            label: 'Estanterías', routerLink: '/facilities/racks',
            requiredPermissions: [PERMISSIONS.RACKS.SHOW_DATA],
          },
          {
            label: 'Muelles',
            routerLink: '/facilities/docks',
            // requiredPermissions: [PERMISSIONS.DOCKS.SHOW_DATA],
          },
          {
            label: 'Sedes',
            routerLink: '/facilities/headquarters',
            requiredPermissions: [PERMISSIONS.HEADQUARTERS.SHOW_DATA],
          },
          { label: 'Zonas', visible: false },
        ],
      },
    ],
  },
  {
    items: [
      {
        icon: 'database',
        label: 'Maestros',
        subItems: [
          {
            label: 'Categorías',
            routerLink: '/masters/categories',
            requiredPermissions: [PERMISSIONS.CATEGORIES.SHOW_DATA],
          },
          { 
            label: 'Clientes',
            routerLink: '/masters/customers',
            requiredPermissions: [PERMISSIONS.CUSTOMERS.SHOW_DATA],
          },
          { label: 'Productos', visible: false },
          {
            label: 'Proveedores',
            routerLink: '/masters/suppliers',
            requiredPermissions: [PERMISSIONS.SUPPLIERS.SHOW_DATA],
          },
          { 
            label: 'Transportadores',
            routerLink: '/masters/carriers',
            requiredPermissions: [PERMISSIONS.CARRIERS.SHOW_DATA],
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        icon: 'sliders-v',
        label: 'Parametrización',
        subItems: [
          { label: 'Diseños', visible: false },
          {
            label: 'Estados de calidad',
            routerLink: '/parameters/quality-statuses',
            requiredPermissions: [PERMISSIONS.QUALITY_STATUSES.SHOW_DATA],
          },
          {
            label: 'Tipos de Entrada',
            routerLink: '/parameters/inbound-types',
            requiredPermissions: [PERMISSIONS.INBOUND_TYPES.SHOW_DATA],
          },
          { label: 'Tipos de Estanterías', visible: false },
          {
            label: 'Tipos de Operación',
            routerLink: '/parameters/operation-types',
            requiredPermissions: [PERMISSIONS.OPERATION_TYPES.SHOW_DATA],
          },
          {
            label: 'Tipos de Salida',
            routerLink: '/parameters/outbound-types',
            requiredPermissions: [PERMISSIONS.OUTBOUND_TYPES.SHOW_DATA],
          },
          {
            label: 'Tipos de Ubicación',
            routerLink: '/parameters/bintypes',
            requiredPermissions: [PERMISSIONS.BINTYPES.SHOW_DATA],
          },
          { label: 'Tipos de Vehículo', visible: false },
          { label: 'UOMs', visible: false },
        ],
      },
    ],
  },
  {
    items: [
      {
        icon: 'shopping-cart',
        label: 'Órdenes',
        visible: false,
        subItems: [{ label: 'Órdenes de entrada' }, { label: 'Órdenes de salida' }],
      },
    ],
  },
];

export const COMPANIES: Company[] = [
  { name: 'Ajinomoto', logo: 'A', color: 'from-emerald-500 to-teal-600' },
  { name: 'Mondelez', logo: 'M', color: 'from-violet-500 to-indigo-600' },
  { name: 'Recamier', logo: 'R', color: 'from-orange-500 to-red-600' },
];
